<template>
  <job-list :filters="clientJobsFilter"
            :filterable="true"
            :show-left-menu="false"
            :go-to-add-on-click="false"
            @on-add="onAdd">
  </job-list>
</template>
<script>
  import { mapState } from 'vuex'
  import JobList from '@/views/admin/jobs/JobList'

  export default {
    name: 'client-management-jobs',
    components: {
      JobList
    },
    computed: {
      ...mapState({
        client: state => state.client.currentClient
      }),
      clientJobsFilter () {
        if (!this.client) return []
        return [
          {
            field: 'client_uuid',
            operator: 'IS',
            value: this.client.uuid
          }
        ]
      }
    },
    methods: {
      onAdd () {
        this.$router.push({path: `/jobs/create`, query: {clientId: this.client.uuid}})
      }
    }
  }
</script>
<style>
</style>
